import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { RoutineCard } from "./RoutineCard";
import { useCarouselAutoplay } from "@/hooks/useCarouselAutoplay";

interface RoutineCarouselProps {
  todayRoutines: any[];
  completedRoutines: any[];
  isRoutineCompleted: (routineId: string) => boolean;
}

export const RoutineCarousel = ({ todayRoutines, completedRoutines, isRoutineCompleted }: RoutineCarouselProps) => {
  const [api, setApi] = useState<any>(null);

  // Usar el hook personalizado de autoplay
  useCarouselAutoplay({
    api,
    delay: 5000,
    stopOnInteraction: true
  });

  return (
    <div className="relative overflow-hidden rounded-xl">
      <Carousel className="w-full" setApi={setApi}>
        <CarouselContent className="-ml-2">
          {todayRoutines.map((routine) => (
            <CarouselItem key={routine.id} className="pl-2 basis-[85%] sm:basis-1/2 md:basis-2/5">
              <RoutineCard 
                routine={routine}
                completed={isRoutineCompleted(routine.id)}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden md:flex" />
        <CarouselNext className="hidden md:flex" />
      </Carousel>
    </div>
  );
};
